import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  SearchPanel,
  Lookup
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarSituacaoDividaDs } from "../../DataSources";
import { simNaoOptions, situacaoCreditoOptions, situacaoInternaOptions, tipoCancelamentoOptions, tipoCobrancaOptions } from "./SituacaoDiatCommon";

const localStorageKey = "cadastroContribuinteGridState";

export default class SituacaoDiatBoxNovo extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: { nome: "" },
    };
    this.situacaoDiatDs = criarSituacaoDividaDs();


  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("situacoesdiat/editar/" + e.data.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="Lista de Situações da Dívida Ativa`"
            novoCb={this.novoContribuinte.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.situacaoDiatDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <Editing allowUpdating={true} useIcons={true} visible={true} />

              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  "edit",
                ]}
              />
              <Column
                dataField={"sequencial"}
                visibleIndex={1}
                allowEditing={false}
                caption={"#"}
                width={80}
              >
                <FormItem visibleIndex={1} />
              </Column>

              <Column dataField={"id"} allowEditing={false} visible={false} />

              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>

              <Column dataField={"nome"} caption={"Nome"} />
              <Column dataField={"situacaoDeCredito"} caption={"Sit. Crédito"}>
                <Lookup valueExpr={"id"} displayExpr={"descricao"} dataSource={situacaoCreditoOptions.dataSource} />
              </Column>
              <Column dataField={"situacaoInterna"} caption={"Sit. Interna"}>
                <Lookup valueExpr={"id"} displayExpr={"descricao"} dataSource={situacaoInternaOptions.dataSource} />
              </Column>
              <Column dataField={"tipoCobranca"} caption={"Tp. Cobrança"}>
                <Lookup valueExpr={"id"} displayExpr={"descricao"} dataSource={tipoCobrancaOptions.dataSource} />
              </Column>
              <Column dataField={"tipoCancelamento"} caption={"Tp. Cancelamento"}>
                <Lookup valueExpr={"id"} displayExpr={"descricao"} dataSource={tipoCancelamentoOptions.dataSource} />
              </Column>
              <Column dataField={"listarParaAcordos"} caption={"Disp. Acordo"}>
                <Lookup valueExpr={"id"} displayExpr={"descricao"} dataSource={simNaoOptions.dataSource} />
              </Column>
              <Column dataField={"listarParaAcompanhamento"} caption={"Disp. Acompanhamento"}>
                <Lookup valueExpr={"id"} displayExpr={"descricao"} dataSource={simNaoOptions.dataSource} />
              </Column>
              <Column dataField={"enviarParaLivro"} caption={"Enviar Livro"}>
                <Lookup valueExpr={"id"} displayExpr={"descricao"} dataSource={simNaoOptions.dataSource} />
              </Column>
              <Column dataField={"listarParaArrecadacao"} caption={"Disp. Arrecadação"}>
                <Lookup valueExpr={"id"} displayExpr={"descricao"} dataSource={simNaoOptions.dataSource} />
              </Column>
              <Column dataField={"chaveMigracao"} caption={"Chave Migração"} visible={false} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoContribuinte() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("situacoesdiat/novo");
  }
}
